if (typeof BSS_B2B != undefined) {
    if (window.location.pathname.includes("/cart")) {
        setTimeout(async () =>{
            const resL = await BSS_B2B?.storage?.productStorage?.load();
            if (resL.notExistProductIds?.length || resL.productIds?.length || resL.variantIds?.size) {
                BSS_B2B?.observer?.productSubject?.notifyObserver("LazyProduct","LoadedLazyProduct", {
                    ...resL,
                });
            }
        }, 4000)
    }
}